module.exports = __webpack_public_path__ + "843f0004fe0c7e51263faf078f80fe64.svg";